// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JBbJ59XI7Tlq5Xg5VF3c{display:flex;align-items:center;flex-direction:column;gap:8px}`, "",{"version":3,"sources":["webpack://./node_modules/aphrodite.react/Components/VerificationCodeEntry/VerificationCodeEntry.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,kBAAA,CACA,qBAAA,CACA,OAAA","sourcesContent":[".container{display:flex;align-items:center;flex-direction:column;gap:8px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JBbJ59XI7Tlq5Xg5VF3c`
};
export default ___CSS_LOADER_EXPORT___;
